import { GET_DAILYCUSTOMER_FAILED, GET_DAILYCUSTOMER_REQUESTED, GET_DAILYCUSTOMER_SUCCESS, GET_RIDEANALYTIC_FAILED, GET_RIDEANALYTIC_REQUESTED, GET_RIDEANALYTIC_SUCCESS, GET_RIDE_FAILED, GET_RIDE_REQUESTED, GET_RIDE_SUCCESS, GET_TOTALREGISTRATION_FAILED, GET_TOTALREGISTRATION_REQUESTED, GET_TOTALREGISTRATION_SUCCESS } from "resources/actionTypes";

const initialState = {
  userRideDetails: [],
  loading: false,
  error: null,
};
const initialStateTotalRegistration = {
  userTotalRegistration: [],
  loading: false,
  error: null,
};
const initialStateRideAnalytic = {
  userRideAnalytic: [],
  loading: false,
  error: null,
};
const initialStateDailyCustomer = {
  userDailyCustomer: [],
  loading: false,
  error: null,
};
export function userRideDetails(state =
  initialState, action) {
  switch (action.type) {
    case GET_RIDE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RIDE_SUCCESS:
      return {
        ...state,
        loading: false,
        userRideDetails: action.userRideDetails
      };
    case GET_RIDE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userTotalRegistration(state =
  initialStateTotalRegistration, action) {
  switch (action.type) {
    case GET_TOTALREGISTRATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TOTALREGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        userTotalRegistration: action.userTotalRegistration
      };
    case GET_TOTALREGISTRATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userRideAnalytic(state =
  initialStateRideAnalytic, action) {
  switch (action.type) {
    case GET_RIDEANALYTIC_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RIDEANALYTIC_SUCCESS:
      return {
        ...state,
        loading: false,
        userRideAnalytic: action.userRideAnalytic
      };
    case GET_RIDEANALYTIC_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userDailyCustomer(state =
  initialStateDailyCustomer, action) {
  switch (action.type) {
    case GET_DAILYCUSTOMER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_DAILYCUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        userDailyCustomer: action.userDailyCustomer
      };
    case GET_DAILYCUSTOMER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}